import ValidateForm, {validator} from "./ValidateForm";
import {sendContacts} from "../services/contact.service";

class ContactUsForm extends ValidateForm {
    constructor(form, options = {}) {
        super(form)

        this.options = options
        this.init()
    }

    init() {
        this.initValidation()
        this.initSubmit()
    }

    initValidation() {
        this.rules = {
            name: validator.required,
            email: value => validator.required(value) && validator.email(value),
            subject: validator.required,
            message: validator.required
        }
    }

    initSubmit() {
        this.form.addEventListener('submit', this.submit.bind(this))
    }

    async submit(e) {
        e.preventDefault()

        const isValid = this.validate()
        if(!isValid)
            return

        this.emit('loading')

        const formData = new FormData(this.form);
        const result = await sendContacts(formData);

        result ? this.emit('success') : this.emit('error');
    }

    resetForm() {
        this.touch = false
        this.form.reset()
    }
}

export default ContactUsForm
